import {SelectOption} from "../../../../../../elements/select/SelectDropdown";
import {CreateBotRequestOpenAiModelEnum} from "../../../../../../../api/generated";

export const OPEN_AI_MODEL_GPT_5_6_SOL = "gpt-5.6-sol" as const;
export const OPEN_AI_MODEL_GPT_5_6_TERRA = "gpt-5.6-terra" as const;
export const OPEN_AI_MODEL_GPT_5_6_LUNA = "gpt-5.6-luna" as const;
export const OPEN_AI_MODEL_GPT_5_4 = "gpt-5.4" as const;
export const OPEN_AI_MODEL_GPT_5_4_NANO = "gpt-5.4-nano" as const;
export const OPEN_AI_MODEL_GPT_5_4_MINI = "gpt-5.4-mini" as const;

export const allOpenAiModelOptions: SelectOption<CreateBotRequestOpenAiModelEnum>[] = [
    {
        label: OPEN_AI_MODEL_GPT_5_6_SOL,
        value: OPEN_AI_MODEL_GPT_5_6_SOL
    },
    {
        label: OPEN_AI_MODEL_GPT_5_6_TERRA,
        value: OPEN_AI_MODEL_GPT_5_6_TERRA
    },
    {
        label: OPEN_AI_MODEL_GPT_5_6_LUNA,
        value: OPEN_AI_MODEL_GPT_5_6_LUNA
    },
    {
        label: OPEN_AI_MODEL_GPT_5_4,
        value: OPEN_AI_MODEL_GPT_5_4
    },
    {
        label: OPEN_AI_MODEL_GPT_5_4_NANO,
        value: OPEN_AI_MODEL_GPT_5_4_NANO
    },
    {
        label: OPEN_AI_MODEL_GPT_5_4_MINI,
        value: OPEN_AI_MODEL_GPT_5_4_MINI
    }
]

export const getOpenAiModelLabel = (model?: string): string => {
    if (!model) {
        return `Default model (${OPEN_AI_MODEL_GPT_5_6_LUNA})`;
    }

    const option = allOpenAiModelOptions.find(option => option.value === model);
    return option?.label || "—";
}
